import { Stack } from '@cmg/design-system';

import { SidePanelTitle } from '../../components/side-bar/components/design-system';

type OfferingDetailsLayoutProps = Readonly<{ children: React.ReactNode }>;

export function OfferingDetailsLayout({ children }: OfferingDetailsLayoutProps) {
  return (
    <Stack spacing={2}>
      <SidePanelTitle>Offering Details</SidePanelTitle>
      {children}
    </Stack>
  );
}
